import searchBar from '../../md-search-bar/_store';
import common from './common';
import searchResult from '../../md-search-result/_store';
import MdHouse from '../../md-house/_store';
import { mergeModules } from '@/store/helpers';

export default mergeModules(MdHouse, common, searchBar, searchResult);
